import { Component, Input, OnInit } from '@angular/core';
import { Shipment } from '../../core/model/shipment';
import { DatePipe } from '@angular/common';
import { OrdersDaoService } from '../../core/dao-service/orders-dao.service';
import { ShopsDaoService } from '../../core/dao-service/shops-dao.service';
import { Order } from '../../core/model/order';
import { Party } from '../../core/model/party';
import { OrdersHistDaoService } from '../../core/dao-service/ordersHist-dao.service';
import { ShipmentsGlsDaoService } from '../../core/dao-service/shipments-gls-dao.service';

@Component({
  selector: 'app-shipment-card',
  templateUrl: './shipment-card.component.html',
  styleUrls: ['./shipment-card.component.scss']
})
export class ShipmentCardComponent {
  @Input() shipment: Shipment;

  creation_date: any;
  orders_code: string[];
  trackList: any[];

  constructor(
    private orderService: OrdersDaoService,
    private orderHistService: OrdersHistDaoService,
    private shopService: ShopsDaoService,
    private glsService: ShipmentsGlsDaoService
  ) { }

  ngOnInit() {

    this.creation_date = new DatePipe('it-IT').transform(this.shipment.creationDate, 'dd/MM/yy HH:mm');
    this.orders_code = [];
    this.trackList = [];

    if (this.shipment.shipmentType === "SHP2LAB") {
      this.glsService.getList("trackpickup", this.shipment.pickupCode).subscribe(list => {
        console.log(list);
        this.trackList = list;
      });
    } else {
      this.glsService.getList("trackshipment", this.shipment.id).subscribe(list => {
        console.log(list);
        this.trackList = list;
      });
    }

    this.shipment.idOrders.forEach(idOrder => {
      this.orderService.get(idOrder).subscribe(
        (order: Order) => {
          const date = new DatePipe('it-IT').transform(order.creationDate, '_dd-MM-yy_HH-mm')
          this.shopService.get(order.shopId).subscribe((shop: Party) => {
            this.orders_code.push(shop.name.substr(0, 6) + date);
          });
        },
        err => {
          console.log(err);
          this.orderHistService.get(idOrder).subscribe((orderHist: Order) => {
            const date = new DatePipe('it-IT').transform(orderHist.creationDate, '_dd-MM-yy_HH-mm')
            this.shopService.get(orderHist.shopId).subscribe((shop: Party) => {
              this.orders_code.push(shop.name.substr(0, 6) + date);
            });
          });

        }
      );
    });
  }

  getLabel(type) {
    switch (type) {
      case 'shop':
        return 'Negozio';
      case 'lab':
        return 'Laboratorio';
      default:
        return 'Indirizzo Cliente';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/shipment-card/shipment-card.component.ts